import React from 'react'
import { Box, Text } from '@chakra-ui/react';
const Blogs = () => {
  return (
    <div>
      <Box height={"70vh"} maxW={"100%"}>
        <Text alignItems={'center'} justifyContent="center"color={"grey"} fontSize={'3xl'} fontWeight={'semibold'} paddingLeft={5}>Coming Soon...</Text>
      </Box>
    </div>
  )
}

export default Blogs